import React from "react";
import { NavLink } from "react-router-dom";
import routes from "routes";
import logo from "assets/img/chisquare.png";
import { cn } from "../../lib/utils";
export default function Sidebar() {
  return (
    <aside
      className={cn(
        "fixed left-0 top-0 h-screen w-64 border-r",
        // ✅ shadcn 톤 적용
        "border-border/60 bg-background/95 backdrop-blur-sm",
        "flex flex-col font-sans text-sm text-muted-foreground"
      )}
    >
      {/* Logo */}
      <div
  className="
    flex items-center justify-start h-14 px-5 
    bg-neutral-950 text-foreground
    shadow-[inset_-1px_0_0_rgba(255,255,255,0.05)]
  "
>
  {/* <img src={logo} alt="ChiSquare logo" className="h-6 opacity-90" /> */}
  <span className="ml-2 text-base font-semibold tracking-tight">ChiSquare</span>
</div>

      {/* Navigation */}
      <nav className="flex flex-col px-3 py-5 space-y-1">
        {routes
          .filter((r) => r.layout === "/admin")
          .map((route, idx) => {
            const fullPath = `${route.layout}${route.path}`.replace(/\/+/g, "/");
            return (
              <NavLink
                key={idx}
                to={fullPath}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 rounded-lg px-3 py-2.5 transition-colors",
                    "hover:bg-neutral-800/60 hover:text-foreground",
                    isActive
                      ? "bg-neutral-800 text-foreground font-medium"
                      : "text-muted-foreground"
                  )
                }
              >
                {route.icon && (
                  <span
                    className={cn(
                      "w-4 h-4 shrink-0",
                      "text-muted-foreground group-hover:text-foreground"
                    )}
                  >
                    {route.icon}
                  </span>
                )}
                <span>{route.name}</span>
              </NavLink>
            );
          })}
      </nav>

      {/* Footer */}
      <div className="mt-auto border-t border-neutral-800 px-4 py-3 text-xs text-muted-foreground">
        © 2025 ChiSquare
      </div>
    </aside>
  );
}